import {NamespaceUtility} from "../model/utility/namespace.js";
import {rootNamespace} from "../service/root.js";

export const rootUtility = new NamespaceUtility(rootNamespace);
